export default {
    "发布职位": "发布职位",
    "基本信息": "基本信息",
    "职位名称和招聘类型发布后不可修改，请准确填写": "职位名称和招聘类型发布后不可修改，请准确填写",
    "招聘类型": "招聘类型",
    "请选择": "请选择",
    "职位名称": "职位名称",
    "请输入职位名称": "请输入职位名称",
    "经验和学历": "经验和学历",
    "请选择工作经验": "请选择工作经验",
    "请选择学历": "请选择学历",
    "薪资范围": "薪资范围",
    "请输入整数": "请输入整数",
    "面议": "面议",
    "职位类型": "职位类型",
    "编辑": "编辑",
    "职位详情": "职位详情",
    "详细的职位介绍信息能帮助你更快找到合适的候选人": "详细的职位介绍信息能帮助你更快找到合适的候选人",
    "查看示例": "查看示例",
    "工作地址": "工作地址",
    "新增地址": "新增地址",
    "投递邮箱": "投递邮箱",
    "新增邮箱": "新增邮箱",
    "发布": "发布",
    "请选择职位分类": "请选择职位分类",
    "最多选择2个": "最多选择2个",
    "请选择此分类下的二级分类": "请选择此分类下的二级分类",
    "个分类": "个分类",
    "请选择工作地址": "请选择工作地址",
    "职位发布成功后，工作城市不可修改": "职位发布成功后，工作城市不可修改",
    "修改": "修改",
    "删除": "删除",
    "确定": "确定",
    "修改工作地址": "修改工作地址",
    "新增工作地址": "新增工作地址",
    "城市": "城市",
    "详细地址": "详细地址",
    "请输入内容": "请输入内容",
    "新增投递邮箱": "新增投递邮箱",
    "请在此处填写您的邮箱账号": "请在此处填写您的邮箱账号",
    "请输入邮箱号": "请输入邮箱号",
    "请选择招聘类型": "请选择招聘类型",
    "请选择职位类型": "请选择职位类型",
    "请输入职位描述": "请输入职位描述",
    "请选择投递地址": "请选择投递地址",
    "社招": "社招",
    "全职": "全职",
    "社招全职": "社招全职",
    "实习生": "实习生",
    "校招": "校招",
    "兼职": "兼职",
    "不限": "不限",
    "1年以下": "1年以下",
    "1-3年": "1-3年",
    "3-5年": "3-5年",
    "5-10年": "5-10年",
    "10年以上": "10年以上",
    "大专": "大专",
    "本科": "本科",
    "硕士": "硕士",
    "博士": "博士",
    "请选择投递邮箱": "请选择投递邮箱",
    "请输入正确的邮箱地址": "请输入正确的邮箱地址",
    "请输入薪资范围": "请输入薪资范围",


    "招聘": "招聘",
    "经验": "经验",
    "发布": "发布",
    "投简历": "投简历",
    "职位描述": "职位描述",
    "工作地点": "工作地点",
    "复制": "复制",
    "投递方式": "投递方式",
    "请将简历+作品集发送至：": "请将简历+作品集发送至：",
    "邮件请注明：求职岗位+姓名+来源MANA": "邮件请注明：求职岗位+姓名+来源MANA",
    "介绍": "介绍",
    "公司相册": "公司相册",
    "项目案例": "项目案例",
    "TA的其他招聘": "TA的其他招聘",
    "查看全部x个职位": "查看全部{count}个职位",
    "艺术家经纪人": "艺术家经纪人",
    "查看该公司所有职位": "查看该公司所有职位",



    "职位": "职位",
    "公司/机构": "公司/机构",
    "发布新职位": "发布新职位",
    "搜索职位/城市/公司": "搜索职位/城市/公司",
    "全部城市": "全部城市",
    "职位性质": "职位性质",
    "查看公司介绍": "查看公司介绍",
    "完善公司信息": "完善公司信息",
    "请先完善公司信息，完善后即可发布职位！": "请先完善公司信息，完善后即可发布职位！",
    "去完善": "去完善",
    "企业认证": "企业认证",
    "您的企业认证信息正在审核中，审核通过后即可发布职位信息，请耐心等待": "您的企业认证信息正在审核中，审核通过后即可发布职位信息，请耐心等待",
    "确定": "确定",
    "请先进行企业认证，认证通过后即可发布招聘信息": "请先进行企业认证，认证通过后即可发布招聘信息",
    "去认证": "去认证",
    "您的企业认证信息未通过，请联系客服": "您的企业认证信息未通过，请联系客服",
    "在招职位": "在招职位",
    "公司/机构介绍": "公司/机构介绍",




    "招聘管理": "招聘管理",
    "有任何疑问可联系MANA小助手，微信号：": "有任何疑问可联系MANA小助手，微信号：",
    "职位管理": "职位管理",
    "公司信息": "公司信息",
    "我的套餐": "我的套餐",
    "购买招聘套餐": "购买招聘套餐",
    "全部": "全部",
    "在线": "在线",
    "已下线": "已下线",
    "审核中": "审核中",
    "未通过": "未通过",
    "审核不通过": "审核不通过",
    "搜索职位名称/城市": "搜索职位名称/城市",
    "发布日期": "发布日期",
    "状态": "状态",
    "操作": "操作",
    "添加公司介绍": "添加公司介绍",
    "选填，最多10张": "选填，最多10张",
    "添加公司相册": "添加公司相册",
    "图片大小不超过10M": "图片大小不超过10M",
    "选填，最多3个": "选填，最多3个",
    "添加项目案例": "添加项目案例",
    "注：项目案例为视频形式，如果您只有图片形式的项目案例，请在公司介绍一栏里添加项目案例相关图片和文字": "注：项目案例为视频形式，如果您只有图片形式的项目案例，请在公司介绍一栏里添加项目案例相关图片和文字",
    "套餐": "套餐",
    "总价": "总价",
    "有效期": "有效期",
    "状态": "状态",
    "职位数": "职位数",
    "剩余职位数": "剩余职位数",
    "编辑公司介绍": "编辑公司介绍",
    "请选择项目案例": "请选择项目案例",
    "提交": "提交",
    "最多3个": "最多3个",
    "视频形式": "视频形式",
    "图片形式": "图片形式",
    "拖拽可调整排序": "拖拽可调整排序",
    "添加标题": "添加标题",
    "上传图片": "上传图片",
    "是否删除该职位？": "是否删除该职位？",
    "提示": "提示",
    "删除成功！": "删除成功！",
    "最多添加3个案例！": "最多添加3个案例！",
    "请选择案例！": "请选择案例！",
    "请输入公司简介！": "请输入公司简介！",
    "修改成功！": "修改成功！",
    "下线": "下线",
    "上线": "上线",
    "公司介绍": "公司介绍",
    "您套餐内的职位数已用完，要发布更多职位请升级招聘套餐或购买职位数。": "您套餐内的职位数已用完，要发布更多职位请升级招聘套餐或购买职位数。",
    "查看我的套餐": "查看我的套餐",
    "购买套餐": "购买套餐",
    "您正在使用招聘套餐免费版，每年可免费发布5个职位。要发布更多职位请升级招聘套餐或购买职位数": "您正在使用招聘套餐免费版，每年可免费发布5个职位。要发布更多职位请升级招聘套餐或购买职位数",
    "了解套餐详情": "了解套餐详情",
    "继续发布": "继续发布",
    "上线职位": "上线职位",
    "上线职位将消耗套餐内的1个职位数，请知晓！": "上线职位将消耗套餐内的1个职位数，请知晓！",
    "您套餐内的职位数已用完，要发布更多职位请升级招聘套餐或购买职位数。": "您套餐内的职位数已用完，要发布更多职位请升级招聘套餐或购买职位数。",
    "下线职位": "下线职位",
    "职位下线后再次上线时将消耗套餐内的1个职位数，确认下线？": "职位下线后再次上线时将消耗套餐内的1个职位数，确认下线？",
    "取消": "取消",
    "下线该职位": "下线该职位",
    "上线该职位": "上线该职位",
    "正在上传": "正在上传",
    "请上传附件简历": "请上传附件简历",
    "简历仅支持Word、PDF、PPT格式的文件，文件大小需小于10M；如您需要投递作品集，可在上传简历附件后填写作品集链接": "简历仅支持Word、PDF、PPT格式的文件，文件大小需小于10M；如您需要投递作品集，可在上传简历附件后填写作品集链接",
    "上传附件简历": "上传附件简历",
    "重新上传": "重新上传",
    "作品集链接": "作品集链接",
    "选填": "选填",
    "简历和作品集链接将会以邮件方式发送到该公司的邮箱": "简历和作品集链接将会以邮件方式发送到该公司的邮箱",
    "正在招聘": "正在招聘",
    "等x个职位": "等{count}个职位",

    "招聘套餐": "招聘套餐",
    "有任何疑问可联系客服，微信号：": "有任何疑问可联系客服，微信号：",
    "基本权益": "基本权益",
    "发布职位数": "发布职位数",
    "无限制": "无限制",
    "增益权限": "增益权限",
    "免费": "免费",
    "购买加油包": "购买加油包",
    "使用套餐": "使用套餐",
    "去购买": "去购买",
    "使用中": "使用中",
    "升级套餐": "升级套餐",
    "升级套餐请联系客服微信：": "升级套餐请联系客服微信：",
    "我知道了": "我知道了",
    "温馨提示": "温馨提示",
    "您尚有未用完的职位数，请使用完后再购买": "您尚有未用完的职位数，请使用完后再购买",
    "个/半年": "个/半年",
    "个/年": "个/年",
    "个/月": "个/月",
    "元/年": "元/年",
    "元/月": "元/月",
    "您的x已过期y天，不再享有套餐内的增益权益。": "您的{x}已过期{y}天，不再享有套餐内的增益权益。",
    "您的x将在a天后过期，还有z个职位未使用，过期后将不再享有增益权益。": "您的{x}将在{a}天后过期，还有{z}个职位未使用，过期后将不再享有增益权益。",
    "最新职位": "最新职位",
    "查看全部": "查看全部",
    "您尚未上传任何项目案例视频，发布后即可添加！": "您尚未上传任何项目案例视频，发布后即可添加！",
    "去上传": "去上传",
    "薪资下限必须小于上限": "薪资下限必须小于上限",
    "已过期": "已过期",
    "数量": "数量",
    "后自动进入招聘管理": "后自动进入招聘管理",
    "招聘/求职": "招聘/求职",
    "求职管理": "求职管理",
    "我的简历": "我的简历",
    "收到的简历": "收到的简历",
    "我要招人": "我要招人"
}


// WEBPACK FOOTER //
// ./src/languages/cn/recruit.js